export const BETSLIP_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://geoffbanks-api.azurewebsites.net': 'https://geoffbanks-api-dev2.azurewebsites.net'
